import { ComponentPropsWithoutRef } from 'react';

export default function Crown(_props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.1321662px"
      height="32.9521633px"
      viewBox="0 0 37.1321662 32.9521633"
      version="1.1"
    >
      <title>50792383-5CAF-4D12-A78A-7232C8B7B712</title>
      <g
        id="leaderboard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="um-/-leaderboard-/-1.1"
          transform="translate(-74.9918, -171.283)"
        >
          <g id="Group-9" transform="translate(74.9918, 142)">
            <g
              id="crown"
              transform="translate(18.5661, 45.7591) rotate(-32) translate(-18.5661, -45.7591)translate(2.5661, 36.3287)"
            >
              <polygon
                id="Stroke-9"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#CFAF00"
                strokeLinejoin="round"
                points="25.2853519 10.7173274 22.751188 7.04646073 19.2980417 9.69032864 16.0001688 11.8605944 12.7019583 9.69032864 9.24881198 7.04646073 6.71464813 10.7173274 6.34854113 13.3355663 16.0001688 16.0775724 25.2853519 14.3274295"
              />
              <polygon
                id="Stroke-2"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#CFAF00"
                strokeLinejoin="round"
                points="10.2422326 5.66283933 9.24983278 7.02823297 7.88443914 6.03583314 8.87683897 4.6704395"
              />
              <polygon
                id="Stroke-3"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#FFD700"
                strokeLinejoin="round"
                points="17.8349533 1.84386766 15.9910857 3.67086671 14.1653842 1.82699906 16.0079543 1.26385617e-12"
              />
              <polygon
                id="Stroke-5"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#FFD700"
                strokeLinejoin="round"
                points="1.84555989 5.34891694 1.67931604 7.02823297 -1.19974579e-12 6.86198912 0.166243849 5.18267309"
              />
              <path
                d="M21.5836836,11.6877021 C18.9533178,10.8438247 15.9997468,3.67086671 15.9997468,3.67086671 C15.9997468,3.67086671 13.0461759,10.8438247 10.4166539,11.6877021 C7.78628805,12.5315795 1.65383094,7.04637634 1.65383094,7.04637634 C3.17304451,9.34228505 4.17180845,11.0642166 4.65012276,12.2121709 C5.10945001,13.3145563 5.51714841,14.9681344 5.87321797,17.1729052 C10.9765427,18.86066 15.9997468,18.86066 15.9997468,18.86066 C15.9997468,18.86066 21.0617555,18.86066 26.1262757,17.1729052 C26.5628118,14.7750147 27.0308601,12.9765968 27.5304206,11.7776516 C27.9685017,10.7262571 28.9069157,9.14916534 30.3456627,7.04637634 C30.3456627,7.04637634 24.2140495,12.5315795 21.5836836,11.6877021 Z"
                id="Stroke-7"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#FFD700"
                strokeLinejoin="round"
              />
              <polygon
                id="Stroke-11"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#CFAF00"
                strokeLinejoin="round"
                points="21.7645998 5.66283933 22.7569996 7.02823297 24.1223932 6.03583314 23.1299934 4.6704395"
              />
              <polygon
                id="Stroke-13"
                stroke="#3E3304"
                strokeWidth="0.3"
                fill="#FFD700"
                strokeLinejoin="round"
                points="30.1544401 5.34891694 30.320684 7.02823297 32 6.86198912 31.8337562 5.18267309"
              />
              <polygon
                id="Path-11"
                fill="#DE1414"
                points="16.0001688 10.4686045 14.312414 12.1563593 14.311992 15.4439214 16.0001688 17.1316762 17.6879236 15.4439214 17.6879236 12.1563593"
              />
              <polygon
                id="Path-11"
                fill="#7254A2"
                points="22.7509134 12.8775962 21.572164 13.8074261 21.5718693 15.6186331 22.7509134 16.5484629 23.9296628 15.6186331 23.9296628 13.8074261"
              />
              <polygon
                id="Path-11"
                fill="#08AB00"
                points="9.24929687 12.8775962 8.07054748 13.8074261 8.07025279 15.6186331 9.24929687 16.5484629 10.4280463 15.6186331 10.4280463 13.8074261"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
